import PromoPerk from './PromoPerk.mjs';

export default function PromoPerks({ promo, perkTax }) {
  let mappedPerks = [];

  if (promo) {
    const mergedApiPerks = [...promo.promoPerks, ...promo.versePerks];

    if (mergedApiPerks.length > 0 ) {
      const tempMappedPerks = mergedApiPerks.map(p => {
        return (
          <PromoPerk
            key={'promo-perk-' + p.name + '-' + Math.floor(Math.random() * 99999)}
            apiPerk={p}
            perkTaxonomies={perkTax}
          />
        );
      });

      mappedPerks.push(tempMappedPerks);
    }
  }

  return mappedPerks.length > 0 ? <div className="icon-wrap d-flex flex-wrap gap-2">{mappedPerks}</div> : false;
}
